import React, { useContext, useEffect, useState } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { Context as PortfolioContext } from '../contexts/portfolio'
import EmmalynImage from '../assets/images/Emmalyn.png'
import HelpRounded from "@material-ui/icons/HelpRounded";
import NotesDataTooltipModal from "../components/NotesDataTooltipModal";

const useStyles = makeStyles({
  subheading: {
    marginBottom: 10,
    fontSize: 14,
    color: '#474747',
    fontWeight: 600,
  },
  section: {
    padding: '26px 20px 20px 30px',
    marginBottom: '20px',
    background: 'white',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
    boxSizing: 'border-box',
  },
  marketContextContainer: {
    borderTop: 'unset',
    background: '#fff',
    margin: 'unset !important',
    width: '100% !important',
  },
  chartContainerMobile: {
    margin: 'auto',
    paddingBottom: '5px !important',
  },
  lgBanner: {
    height: '100%',
    width: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  leftSection: {
    display: 'flex',
  },
  toolTip: {
    color: '#8c8c8c',
    margin: 'auto',
    fontSize: '1.8rem',
    cursor: 'pointer',
    marginLeft: '5px',
    marginTop: -3,
    height: '30px',
  },
  toolTipMobile: {
    color: '#8c8c8c',
    margin: 'auto',
    fontSize: '1.3rem',
    cursor: 'pointer',
    marginLeft: '5px',
    marginTop: -3,
    height: '30px',
  },
  head: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #DFE4EB',
  },
  mobileHead: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #DFE4EB',
  },
  noDataText: {
    fontSize: 15,
  },
  main: {
    overflow: 'auto',
    borderRadius: '3px',
    padding: 0,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  mainMobile: {
    height: '250px',
    overflow: 'auto',
    borderRadius: '3px',
    padding: 0,
    '&::-webkit-scrollbar': {
      width: 5,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D1',
      borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#D1D1D1',
    },
  },
  leftMobileSection: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flexStart',
    flexDirection: 'row',
  },
})

const NoteContext = ({ tickerId }) => {
  const classes = useStyles()
  const { state } = useContext(PortfolioContext)
  const [openTooltip, setOpenTooltip] = React.useState(false)

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [time, setTime] = useState(0);
  const longText = state?.notesData?.signal_overview;
  const words = longText.split(' ');

  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }

  useEffect(() => {
    if (currentWordIndex < words.length) {
      if(time >= 5000) {
        setCurrentWordIndex((prevIndex) => words.length);
      } else {
        const intervalId = setInterval(() => {
          setTime((prevIndex) => prevIndex + 30);
          setCurrentWordIndex((prevIndex) => prevIndex + 1);
        }, 30);
        return () => clearInterval(intervalId);
      }
    }
  }, [currentWordIndex]);

  return (
      <section
          className={classes.section}
          style={
            isMobile
                ? { padding: '20px 16px' }
                : { minWidth: '1300px' }
          }
      >
        <div
            className={isMobile ? classes.mobileHead : classes.head}
            style={{ paddingBottom: isMobile ? '16px' : '26px' }}
        >
          {!isMobile && (
              <>
                <div className={classes.leftSection}>
                  <Typography
                      className={classes.title}
                      style={{ fontSize: isMobile ? 18 : 20 }}
                  >
                    Emmalyn Insights
                  </Typography>
                  <HelpRounded
                      className={classes.toolTip}
                      key="1"
                      onClick={() => handleClickOpenTooltip()}
                  />
                </div>
              </>
          )}

          {isMobile && (
              <div className={classes.leftMobileSection}>
                <Typography className={classes.title}>
                  Emmalyn Insights
                </Typography>
                <HelpRounded
                    className={classes.toolTipMobile}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                />
              </div>
          )}
        </div>

        <Grid className={classes.marketContextContainer} container spacing={3}>
          <Grid
              className={
                isMobile ? classes.chartContainerMobile : classes.chartContainer
              }
              item
              // xs={6}
              sm={2}
          >
            <img src={EmmalynImage} alt="Emmalyn Image" style={{ width: "100%", height: "200px", display: "flex", alignItems: "center"}}/>
          </Grid>

          <Grid
              className={
                isMobile
                    ? classes.newsListContainerMobile
                    : classes.newsListContainer
              }
              item
              // xs={18}
              sm={10}
          >
            <div className={isMobile ? classes.mainMobile : classes.main}>
              <Typography className={classes.noDataText}>
                {words.slice(0, currentWordIndex).join(' ')}
                <span className="cursor" style={{opacity: currentWordIndex >= words.length ? 0 : 1}}>&#10074;</span>
              </Typography>
            </div>
          </Grid>
        </Grid>
        <NotesDataTooltipModal
            open={openTooltip}
            handleClose={() => {
              setOpenTooltip(false)
            }}
        />
      </section>
  )
}

export default NoteContext
